import React from 'react';
import { EventCategoryPage } from '../../components/Events/EventCategoryPage';
import { EVENT_CATEGORIES } from '../../data/eventCategoryData';
const ReadingRetreats = () => <EventCategoryPage config={EVENT_CATEGORIES['reading-retreats']} data-id="element-9880" data-mp="9hzr3a4f16tl" />;
export default ReadingRetreats;